'use client';

import { clsx } from 'clsx';
import { FC, PropsWithChildren, useState } from 'react';

import { IconQuestionMarkEmpty } from 'src/general/Icons/IconQuestionMarkEmpty';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

import { BasicModal } from '../BasicModal/BasicModal';
import { Button } from '../Button/Button';
import { Shade } from '../Shade/Shade';

type Props = {
  entryId: string;
  title: string;
  modalTitle: string;
  className?: string;
  closeButton?: boolean;
  iconOnly?: boolean;
  event?: string;
};

export const HelperModal: FC<PropsWithChildren<Props>> = ({
  entryId,
  title,
  modalTitle,
  children,
  className,
  closeButton,
  iconOnly,
  event,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onOpen = () => {
    setIsOpen(true);
    pushToDataLayer({
      event: event ?? `open_helper_modal`,
      value: entryId,
      label: title,
    });
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        className={clsx('HelperModal-trigger', 'c-shade_container', { ['HelperModal--iconOnly']: iconOnly })}
        onClick={onOpen}
        type="button"
        data-testid="HelperModal-trigger"
      >
        <Shade />
        <span className="HelperModal-triggerContent">
          <IconQuestionMarkEmpty size={20} />
          {!iconOnly && <span className="pt-px">{title}</span>}
        </span>
      </button>
      <BasicModal
        id={entryId}
        isOpen={isOpen}
        onClose={onClose}
        title={modalTitle}
        className={clsx('HelperModal', className)}
        footer={closeButton && <Button onClick={onClose}>Close</Button>}
      >
        {children}
      </BasicModal>
    </>
  );
};
